// extracted by mini-css-extract-plugin
export default {"tooltip-ui":"cFXnCZA4YtfXMxMCJ35I"};